module.exports = __webpack_public_path__ + "static/img/fefco420_2.3ba7e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco420_2.png
// module id = 7s4x
// module chunks = 0